import { Button, Typography, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import { ScheduleCreateContext, ScheduleCreateValues } from '../context/ScheduledReportsContext';
import { useContext } from 'react';
import { CloseDialogAction } from '../../../components/shared/dialogs/CloseDialogAction';

const DeleteTaskType = () => {
  const { t,
    openDeleteModal,
    handleClose,
    confirmDeleteTask,
  } = useContext(ScheduleCreateContext) as ScheduleCreateValues;

  return (
    <Dialog open={openDeleteModal}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>
        {t('deleteType')}
        <CloseDialogAction onCancel={handleClose} />
      </DialogTitle>
      <DialogContent>
        <Typography>{t('deleteTypeWarning')}</Typography>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          size='lg'
          onClick={handleClose}>{t('cancel')}</Button>
        <Button variant="bad"
          size='lg'
          onClick={confirmDeleteTask}>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTaskType;